module.exports = ` ...on AkashiTitle
{
    nameEn
    contentTitle
    styles
}`;
